"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useCallback } from "react";
import { useAuthDialogStore } from "@/features/auth/store/auth-dialog-store";

type AuthEvent = "login" | "sign_up";

/**
 * Opens the shared auth dialog and keeps the user where they were. The `event`
 * param is what the GTM handler reads once the session is active.
 */
export const useOpenAuthDialog = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const openAuthDialog = useAuthDialogStore((store) => store.openAuthDialog);

  return useCallback(
    (event: AuthEvent = "login") => {
      const params = new URLSearchParams(searchParams);
      params.set("event", event);

      openAuthDialog(`${pathname}?${params.toString()}`);
    },
    [openAuthDialog, pathname, searchParams],
  );
};
